import React from "react";
import Container from "../components/Layouts/Container";
import JobBrampton from "../components/Jobs/JobBrampton";

const JobBramptonPage = () => {
  return (
    <Container>
      <JobBrampton />
    </Container>
  );
};

export default JobBramptonPage;
